import { Component, Input } from '@angular/core';

@Component({
    selector: 'gl-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    standalone: false
})
export class ErrorComponent {
  @Input() public message: string;
}

export const ERRORS_KEYS = {
  required: 'error_required',
  email: 'error_email',
  mismatch: 'error_mismatch',
  notVerified: 'error_not_verified',
  wrongProvider: 'error_wrong_provider',
  noEmailFound: 'error_email',
  wrongPassword: 'error_no_password',
  wrongPasswordOrEmail: 'wrong_password_or_email',
  emailAlreadyExists: 'error_email_already_exists',
  notUnique: 'error_name_not_unique',
  notInteger: 'error_not_number',
  notFloat: 'error_not_number',
  minlength: 'error_too_short',
  maxlength: 'error_too_long',
  wrongOldPassword: 'wrong_old_password',
  maxLoadingSpace: 'max_loading_spaces',
  changeName: 'rename',
  pattern: 'error_not_number',
  max: 'error_value_too_big',
  min: 'error_value_too_low',
  maxValue: 'error_value_too_big',
  minValue: 'error_value_too_low',
  wrongCode: 'wrong_code',
  equalValue: 'error_equal_value_nip',
  userAlreadyHasPremium: 'user_already_has_premium',
  emptySlot: 'empty_slot',
  doorMax: 'door_dimensions_exceed_width_and_height_of_the_container',
  coolerMax: 'cooler_must_not_protrude_beyond_load_space',
  wheelMax: 'wheel_arches_must_not_protrude_beyond_load_space',
  maxVarioFloorThickness: 'floor_must_not_protrude_beyond_load_space',
  minVarioFloorThickness: 'floor_must_not_protrude_beyond_load_space',
  maxVarioFloorCapacity: 'floor_capacity_not_greater_than_capacity_cargo_space',
  gravityMax: 'specified_values_exceed_width_and_length_of_the_container',
  invalidFirstOperation: 'first_operation_must_be_loading',
  invalidLastOperation: 'last_operation_must_be_unloading',
  invalidBeginDate: 'begin_date_must_be_before_end_date',
  invalidEndDate: 'end_date_must_be_after_begin_date',
  invalidDateBeforeToday: 'date_must_be_later_than_today',
  invalidDateTodayPlus30Min: 'date_and_time_must_be_today_and_at_least_30_minutes_from_now',
  invalidChronologicalOrder: 'dates_must_be_in_chronological_order',
  endBeforeBegin: 'end_date_must_be_after_begin_date',
  beginAfterEnd: 'begin_date_must_be_before_end_date',
  invalidDate30MinApart: 'dates_must_be_30_min_apart',
};
